import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import * as compress from 'graphql-query-compress';

@Injectable()
export class CoreoService {

    private host = 'https://api.coreo.io';

    private apiKey = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9' +
        '.eyJrZXkiOiJkM2Q0MDZkZmVkYzM2NzdmNjEzMDIyOTcxODNlMjRkMCIsImlhdCI6MTUxMTk3MDc4MCwiaXNzIjoiY29yZW8ifQ' +
        '.YWfOjC0b6yMABePiRsCMYPM6-5NL_nFo9D0rkZfkfCY';

    constructor(private http: Http) {
    }

    get(path: string): Observable<Response> {
        return this.http.get(this.buildUrl(path), {
            headers: this.buildHeaders()
        });
    }

    post(path: string, body: any): Observable<Response> {
        return this.http.post(this.buildUrl(path), body, {
            headers: this.buildHeaders()
        });
    }

    put(path: string, body: any): Observable<Response> {
        return this.http.put(this.buildUrl(path), body, {
            headers: this.buildHeaders()
        });
    }

    delete(path: string): Observable<Response> {
        return this.http.delete(this.buildUrl(path), {
            headers: this.buildHeaders()
        });
    }

    query(query: string): Observable<any> {
        return this.get('/graphql?query=' + encodeURI(compress(query)))
            .map(result => result.json().data);
    }

    go(path: string) {
        window.location.href = this.buildUrl(path);
    }

    private buildUrl(path: string) {
        return this.host + (path.startsWith('/') ? '' : '/') + path;
    }

    private buildHeaders() {
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set('Authorization', 'JWT ' + this.apiKey);

        return headers;
    }

    photoUrl(recordId, path, height?, width?, dpr?) {
        let url = this.buildUrl('/records/' + recordId + '/images/' + path);
        let args = ['fit=crop'];
        if (typeof height !== 'undefined') {
            args.push('height=' + height);
        }
        if (typeof width !== 'undefined') {
            args.push('width=' + width);
        }
        if (typeof dpr !== 'undefined') {
            args.push('dpr=' + dpr);
        }

        if (args.length === 0) {
            return url;
        } else {
            return url + '?' + args.join('&');
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/services/coreo.service.ts